module.exports = __webpack_public_path__ + "static/media/2 3 Ordkjedetest-Feil-los-tupp-meg-sa.b8e331b2.m4a";